import React, {useEffect} from "react";
import {AEInput, CardBody, CardFooter, CardHeader} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {AESVG} from "../../../../../_emywork/components/svg";
import {useIntl} from "react-intl";
import {AEMetadata} from "../../../../../_emywork/AEPagination";
import {Dropdown} from "react-bootstrap";
import {DropdownCustomToggler} from "../../../../../_metronic/_partials/dropdowns";
import {AEEmail, AEPhone} from "../../../../../_emywork/components/AELink";
import KTAppChat from "../../../../../_metronic/_assets/js/components/chat";
import * as actions from "../../../Contacts/_redux/actions";
import {useModuleContext} from "../../ModuleContext";
import {actionTypes} from "../../_redux/slice";
import {AEFileDownload} from "../../../../../_emywork/components/AEFileDownload";

export function Content({id, onUpdate}) {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const {openDeleteDialog, openEditPage} = useModuleContext();
  const { authUser } = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );


  const { entity } = useSelector(
    state => {
      return state.contacts[actionTypes.Details]
    }
    , shallowEqual )

  const refresh = () =>{
    dispatch(actions.fetchEntity(
      id,
      new AEMetadata({},{},{},['id', 'name', 'phone', 'email', 'note','file_name']),
      actionTypes.Details
    )).then(r=>{
      KTAppChat.init();
    });
  }

  useEffect(() => {
    if(id) {
      refresh()
    }
  }, [dispatch, id]);

  const Header = ({title}) => <div className='font-size-h3 pb-5'>{formatMessage({id:title})}</div>


  return (
    <div className="card card-custom card-stretch">
      <CardHeader className="align-items-center align-items-between px-4 py-3">
        <div className="mr-auto font-weight-bolder font-size-h3">
          <AESVG
            path={"/Communication/Adress-book2.svg"}
            size={'2x'}
            className={'pr-3'}
            // variant={id === contact.id ? 'primary' : ''}
          />
          {entity.name}
        </div>
        <div className="">
          <Dropdown>
            <Dropdown.Toggle as={DropdownCustomToggler} >
              <AESVG size={'lg'} path={'/General/Settings-1.svg'} />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
              <Dropdown.Item
                onClick={() => {
                  openEditPage(id)
                }}
              >
                {formatMessage({id: 'EDIT'})}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  openDeleteDialog(id)
                }}
              >
                {formatMessage({id: 'DELETE'})}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

      </CardHeader>
      <CardBody>
        <div>
          <Header title={'NOTE'} />
          <p className="mb-7">
            {entity.note}
          </p>
        </div>
        <div>
          <Header title={'CONTACT'} />
          {
            [
              {id: "PHONE", svg:"/Communication/Call.svg", value: <AEPhone value={entity.phone} />},
              {id: "EMAIL", svg:"/Communication/Mail.svg", value: <AEEmail value={entity.email} />},
              // {id: "ADDRESS", svg:"/Map/Marker1.svg", value: _address.join(' - ')}
            ]
              // .filter(op=>op.value)
              .map(op=>(
                <div key={op.id} className="d-flex mb-5">
                  <AESVG
                    size={'md'}
                    className={"flex-shrink-0 mr-3"}
                    path={op.svg}
                  />
                  <span className="">
                  {op.value}
                    <span className={"text-muted ml-2"}>
                    {formatMessage({id: op.id})}
                  </span>
                </span>
                </div>
              ))
          }
        </div>
        {
          entity.file_name &&
          <div>
            <Header title={'FILE'} />
            <AEFileDownload id={id} target={'contacts'} fileName={entity.file_name} />
          </div>
        }

      </CardBody>
    </div>
  );


}
